import { RootState } from 'redux/schemas';
import { CourseAdminDashboardState } from 'redux/schemas/models/course-admin';

// eslint-disable-next-line import/prefer-default-export
export const getCourseAdminDashboardState = (state: RootState): CourseAdminDashboardState => state.app.courseAdminDashboard;
